import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import {
  Modal,
  Button
} from "react-bootstrap"

const getAlertType = (type, cb, error) => {
  if (!type) { cb.error(error) };
  switch (type) {
    case 'info':
      return cb.info(error);
    case 'success':
      return cb.success(error);
    case 'warning':
      return cb.warning(error);
    case 'error':
      return cb.error(error);
    default:
      break;
  }
}

export default class AlertService {

  static checkMessageType = (respcode) => {
    switch (respcode) {
      case 0:
        return "success"
      case 1:
        return "error"
      case 2:
        return "warning"
      case 3:
        return "info"
      case 4:
        return "warning"
      default:
        return "error"
    }
  };

  // static alert = (type, error) => {
  //   const respMessage = typeof error === "object" ? error.message || error.respmess : error;
  //   if (!respMessage || (respMessage && respMessage.includes("401")) || (respMessage && respMessage.toLowerCase().includes("user is not authenticated")) ) { return false; }
  //   getAlertType(type, toast, respMessage);
  // }

  static alert = (type, error) => {
    if (!error) return false;

    const respMessage =
      typeof error === "object"
        ? error.message ?? error.respmess ?? ""
        : String(error || "");

    if (
      !respMessage.trim() ||
      respMessage.includes("401") ||
      respMessage.toLowerCase().includes("user is not authenticated")
    ) {
      return false;
    }

    getAlertType(type, toast, respMessage);
  };

  static alertConfirm = (title, message, yes, no) => {
    return new Promise((resolve, reject) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Modal
              show={true}
              onHide={onClose}
              scrollable={true}
              className='alert-confirm-modal'
            >
              <Modal.Header className='' closeButton>
                <h4 className='mb-0'> {
                  title ? title : null
                }</h4>
              </Modal.Header>
              {
                message ?
                  <Modal.Body>
                    <p className='mb-0'>{message}</p>
                  </Modal.Body>
                  : null
              }
              <Modal.Footer>
                <div className='d-flex justify-content-end gap-2'>
                  <Button
                    type="button"
                    variant='outline-secondary'
                    className="px-4"
                    onClick={() => { onClose(); }}
                  >
                    {no}
                  </Button>
                  <Button
                    type="button"
                    variant='primary'
                    className="px-4"
                    onClick={() => { resolve(); onClose(); }}
                  >
                    {yes}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )
        }
      })
    })
  }

}
